import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({


    routes: [
        {
            name: 'home',
            path: '/',
            component: () => import('@/pages/home/Home')
        },
        {
            name: 'jczqList',
            path: '/jczq',
            component: () => import('@/pages/jczq/List')
        },
        {
            name: 'jclqList',
            path: '/jclq',
            component: () => import('@/pages/jclq/List')
        },
        {
            name: 'jczqDgList',
            path: '/jczqDg',
            component: () => import('@/pages/jczq/DgList')
        },
        {
            name: 'jclqDgList',
            path: '/jclqDg',
            component: () => import('@/pages/jclq/DgList')
        },
        {
            name: 'betContent',
            path: '/betContent',
            component: () => import('@/pages/bet/Content')
        },
        {
            name: 'myBet',
            path: '/recordList',
            component: () => import('@/pages/bet/RecordList'),
            meta: {
                requireAuth: true,
                keepAlive:true,
            }
        },
        {
            name: 'betDetail',
            path: '/betDetail',
            component: () => import('@/pages/bet/Detail')
        },
        {
            name: 'signIn',
            path: '/sign',
            component: () => import('@/pages/user/SignIn')
        },
        {
            name: 'login',
            path: '/login',
            component: () => import('@/pages/user/Login'),
        },
        {
            name: 'mine',
            path: '/mine',
            component: () => import('@/pages/user/Mine'),
            meta: {
                requireAuth: true
            }
        },
        {
            name: 'changePWD',
            path: '/changePWD',
            component: () => import('@/pages/user/ChangePWD'),
            meta: {
                requireAuth: true
            }
        },
        {
            name: 'charge',
            path: '/charge',
            component: () => import('@/pages/user/Charge'),
            meta: {
                requireAuth: true
            }
        },
        {
            name: 'detailOrder',
            path: '/detailOrder',
            component: () => import('@/pages/bet/DetailOrder'),
            meta: {
                requireAuth: true
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js